export default "__VITE_ASSET__DKky3NUs__"